<template>
  <v-dialog v-model="dialogOpen" width="750" @click:outside="close">
    <v-card :loading="telcoLinesCliHistoriesLoading">
      <v-card-title>CLI History</v-card-title>
      <template v-if="!telcoLinesCliHistoriesLoading">
        <v-card-text>
          <v-row>
            <v-col>
              <v-data-table :headers="headers" :items="getTelcoLinesCliHistories">
                <template v-slot:item.timestampFormatted="{ item }"><span class="body--text">{{ item.timestampFormatted }}</span></template>
                <template v-slot:item.previous_value="{ item }"><span class="body--text">{{ item.previous_value }}</span></template>
                <template v-slot:item.new_value="{ item }"><span class="body--text">{{ item.new_value }}</span></template>
                <template v-slot:item.change_reason="{ item }"><span class="body--text">{{ item.change_reason }}</span></template>
                <template v-slot:item.user="{ item }"><span class="body--text">{{ item.user }}</span></template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" small outlined @click="close">CLOSE</v-btn>
        </v-card-actions>
      </template>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState,mapActions,mapGetters } from 'vuex';
export default {
  props: ['productID', 'dialogOpen'],
  data() {
    return {
      headers: [
        {text: 'Time',sortable: false,value: 'timestampFormatted'},
        {text: 'Old CLI',sortable: false,value: 'previous_value'},
        {text: 'New CLI',sortable: false,value: 'new_value'},
        {text: 'Reason',sortable: false,value: 'change_reason'},
        {text: 'User',sortable: false,value: 'user'},
      ],
    }
  },
  computed: {
    ...mapGetters('productCli', ['getTelcoLinesCliHistories']),
    ...mapState('productCli', ['telcoLinesCliHistoriesLoading']),
  },
  watch: {
    async dialogOpen(open) {
      if(open){
        this.fetchTelcoLinesCliHistories({
          productId: this.productID,
          opts: {
            params: {
              attribute: 'line_number',
              sort: 'creation_timestamp',
              order: 'desc'}}});
      }
    },
  },
  methods: {
    ...mapActions('productCli',['fetchTelcoLinesCliHistories']),
    close() {
      this.$emit('close-dialog');
    },
  },
}
</script>

<style lang="scss" scoped></style>
